module.exports = __webpack_public_path__ + "static/media/logo-white-transparent.b4ac4703.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-white-transparent.gif
// module id = 661
// module chunks = 15